import {
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UserFacade } from '@cigna/chcp/shared/user-profile-data-access';
import { AppContext } from '@cigna/chcp/shared/util';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'cigna-wam-onboarding-screen',
  templateUrl: './wam-onboarding-screen.component.html',
  styleUrls: ['./wam-onboarding-screen.component.scss'],
})
export class WamOnboardingScreenComponent {
  @Input() onboardingStatus: string;
  @Input() firstName: string;
  @Input() isImpersonator: boolean;
  @Input() appContext: AppContext;

  @Output() hideWamScreen = new EventEmitter();

  @ViewChild('dismissModal', { static: true })
  dismissModal: TemplateRef<unknown>;
  dialogRef: MatDialogRef<unknown>;

  currentStep = 0;

  constructor(
    private userFacade: UserFacade,
    private dialog: MatDialog,
    private cookieService: CookieService,
  ) {}

  previous() {
    this.currentStep = this.currentStep - 1;
  }

  continueOnboarding() {
    this.currentStep = this.currentStep + 1;
  }

  completeOnboarding() {
    this.cookieService.set('wamOnboardingHidden', 'true', 1);
    this.userFacade.updateProfileIndicator('wamOnboarding');
    this.hideWamScreen.emit();
  }

  skipOnboarding() {
    this.cookieService.set('wamOnboardingHidden', 'true', 1);

    const dontShowBox = document.getElementById(
      'dontShowBox',
    ) as HTMLInputElement;

    if (dontShowBox.checked) {
      this.userFacade.updateProfileIndicator('wamOnboarding');
    }

    this.hideWamScreen.emit();

    this.dialog.closeAll();
  }

  dismissConfirm() {
    this.dialogRef = this.dialog.open(this.dismissModal, {
      autoFocus: false,
      width: '600px',
    });
  }
}
